import { NodeTypes } from "@/workflow_api/types/workflow";

export interface MergeEntry {
  name: string;
  nodeId: string;
  type: "MERGE_ENTRY";
}

export interface MergeNodeTypeInput {
  name: "merge_node_type";
  value: string;
  type: "STRING";
}

export interface MergeNodeData {
  nodeType: string;
  entries: MergeEntry[];
  manualConfirmation: boolean;
  connections: {
    default: {
      display_name: string;
      target_node: string | null;
    };
  };
}

export interface MergeNodeConfig {
  merge_node_type: string;
  entries: MergeEntry[];
  manual_continue: boolean;
  display_name?: string;
}

export const RESTRICTED_NODE_TYPES = [
  NodeTypes.FORM,
  NodeTypes.DATA_CENTER,
  NodeTypes.CORRECTION,
] as const;
export const MIN_ENTRIES = 2;
export const MAX_ENTRIES = 10;
